// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__UNdsQ","cover":"not-found_cover__LIJqf","info":"not-found_info__k92T0","title":"not-found_title__EK6ie","link":"not-found_link__AHmCv"};